/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime'
import type { GetDatasetDetailsResponse, GetDatasetVersionResponse, UpdateDatasetRequest } from '../models/index'

export interface GetDatasetDetailsRequest {
  datasetId: string
}

export interface UpdateDatasetOperationRequest {
    datasetId: string;
    updateDatasetRequest: UpdateDatasetRequest;
}

/**
 * 
 */
export class DatesetControllerApi extends runtime.BaseAPI {
  /**
   */
  async getDatasetDetailsRaw(
    requestParameters: GetDatasetDetailsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetDatasetDetailsResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling getDatasetDetails().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}`.replace(
          `{${'datasetId'}}`,
          encodeURIComponent(String(requestParameters['datasetId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async getDatasetDetails(
    requestParameters: GetDatasetDetailsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetDatasetDetailsResponse> {
    const response = await this.getDatasetDetailsRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async updateDatasetRaw(
    requestParameters: UpdateDatasetOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetDatasetVersionResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling updateDataset().',
      )
    }

    if (requestParameters['updateDatasetRequest'] == null) {
      throw new runtime.RequiredError(
        'updateDatasetRequest',
        'Required parameter "updateDatasetRequest" was null or undefined when calling updateDataset().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}`.replace(
          `{${'datasetId'}}`,
          encodeURIComponent(String(requestParameters['datasetId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['updateDatasetRequest'],
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async updateDataset(
    requestParameters: UpdateDatasetOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetDatasetVersionResponse> {
    const response = await this.updateDatasetRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
